import {RequestStatus, RequestStatusesEnum} from '@innowise-group/core';
import {Theme} from '@innowise-group/ui-kit';

const getColorByRequestType = (
  type: RequestStatus,
  {
    palette: {
      general: {darkGrey},
      state: {error, success, warning},
      main,
    },
  }: Theme,
): string => {
  switch (type) {
    case RequestStatusesEnum.Approved:
      return success.default;
    case RequestStatusesEnum.InClarification:
      return main.default;
    case RequestStatusesEnum.Conflict:
      return warning.default;
    case RequestStatusesEnum.Rejected:
      return error.default;
    case RequestStatusesEnum.Delayed:
      return darkGrey[60];
    case RequestStatusesEnum.Canceled:
      return darkGrey[60];
  }
};

export default getColorByRequestType;
